import { _bootstrap } from "state/store.bootstrap";
import { getFocus, useAtom, useGet } from "state/jotai";
import {
  active_project,
  current_language,
  rotate_by_slider,
} from "state/store.global";
import { AnimatePresence, motion } from "framer-motion";
import { _project } from "state/store.projects";
import { useBreak } from "hooks/useBreak";
import { InnerDesktopLabel } from "./InnerDesktopLabel";
// import { InnerMobileLabel } from "./InnerMobileLabel";

export const InnerIsometryLabels = ({
  status,
  //   scale,
  rmode,
  showLabel,
  setShowLabel,
  hoveredId,
  hoveredPos,
  index,
}) => {
  const labelOptions = getFocus(_bootstrap, "projectnames");

  const [currentLanguage] = useAtom(current_language);
  const isRotateDone = useGet(rotate_by_slider);
  const isDesktop = useBreak("md_up");
  const isMobile = !isDesktop;
  /** assuming project status & index come from project store */
  const project = useGet(_project);
  const { pin, pid } = useGet(active_project);

  const L = {
    1: [
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1280, 950], L2: [170, 1000] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
    ],
    2: [
      { L1: [1650, 800], L2: [2650, 1050] },
      { L1: [1300, 600], L2: [200, 950] },
      { L1: [1650, 800], L2: [2650, 1050] },
      { L1: [1650, 800], L2: [2650, 1050] },
      { L1: [1680, 1050], L2: [2700, 1200] },
    ],
    3: [
      { L1: [2280, 800], L2: [2700, 1000] },
      { L1: [1280, 950], L2: [170, 1000] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
    ],
    4: [
      { L1: [2280, 800], L2: [2700, 1000] },
      { L1: [1280, 950], L2: [170, 1000] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1680, 1050], L2: [2700, 1200] },
    ],
  };

  const circle = {
    1: [
      { L1: [50, 20], L2: [50, 20] },
      { L1: [50, 20], L2: [50, 20] },
      { L1: [50, 20], L2: [50, 20] },
    ],
    // 2: [{ L1: [50, 300], L2: [50, 300] }, { L1: [50, 300], L2: [50, 20] },{ L1: [50, 300], L2: [50, 300] }],
    // 3: [{ L1: [50, 300], L2: [50, 300] }],
  };
  const MobilePositions = {
    1: [
      { L1: [1680, 1050], L2: [2700, 1200] },
      { L1: [1250, 900], L2: [200, 1050] },
      { L1: [1680, 1050], L2: [2700, 1200] },
    ],
  };
  const MobileCircle = {
    1: [
      { L1: [50, 20], L2: [50, 20] },
      { L1: [50, 20], L2: [50, 20] },
      { L1: [50, 20], L2: [50, 20] },
    ],
  };
  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.1 },
  };

  return (
    <AnimatePresence>
      {status === "DONE" && isRotateDone && (
        <>
          {/* ================= DESKTOP LABELS ================= */}
          {isDesktop &&
            labelOptions?.[currentLanguage]?.map((label, i) => {
              const pos = L?.[pin]?.[index]?.[`L${i + 1}`];
              const rad = circle?.[pin]?.[index]?.[`L${i + 1}`];

              if (!pos) return null;

              return (
                <motion.div key={`desktop-${i}`} {...animation}>
                  <InnerDesktopLabel
                    heading={label?.Presentation}
                    // scale={scale}
                    setShowLabel={setShowLabel}
                    c={pos}
                    sc={1}
                    d={40}
                    l={0}
                    r={rad}
                    rmode={rmode}
                    labelsInfo={label}
                    showLabel={showLabel}
                    hoveredId={hoveredId}
                    hoveredPos={hoveredPos}
                    clr={clr}
                  />
                </motion.div>
              );
            })}

          {/* ================= MOBILE LABELS ================= */}
          {/* {isMobile &&
            IsoAreaOptions.map((label, i) => {
            const pos =
  MobilePositions?.[pin]?.[index]?.[`L${i + 1}`];
    const rad = MobileCircle?.[pin]?.[0]?.[`L${i + 1}`];

              if (!pos) return null;

              return (
                <motion.div key={`mobile-${i}`} {...animation}>
                  <InnerMobileLabel
                    heading={label?.Presentation}
                    scale={scale}
                    c={pos} // ✅ same as desktop
                    r={rad} // ✅ circle coords
                    sc={1}
                    d={40}
                    l={0}
                    labelsInfo={label}
                    hoveredId={hoveredId}
                    clr={clr}
                  />
                </motion.div>
              );
            })} */}
        </>
      )}
    </AnimatePresence>
  );
};
